// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3ucKv","additionalInfo":"AgreementModal_additionalInfo__2NLoT"};